import { useContext } from "react"
import { ParametrosClienteFielContext } from "./ParametrosClienteFielContext"

export function useParametrosClienteFielContext() {
    return useContext(ParametrosClienteFielContext)
}
